import pt from "./pt.json";
import ptLocale from "element-ui/lib/locale/lang/pt";
export default {
  ...pt,
  ...ptLocale,
};